var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRightBold = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 12",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.89838 0.709355C8.24294 0.377109 8.79159 0.387085 9.12383 0.731636L13.6238 5.3983C13.9476 5.73403 13.9476 6.26574 13.6238 6.60147L9.12383 11.2681C8.79159 11.6127 8.24294 11.6227 7.89838 11.2904C7.55383 10.9582 7.54386 10.4095 7.8761 10.065L10.9603 6.86655H0.999967C0.521321 6.86655 0.133301 6.47853 0.133301 5.99989C0.133301 5.52124 0.521321 5.13322 0.999967 5.13322H10.9603L7.8761 1.9348C7.54386 1.59025 7.55383 1.0416 7.89838 0.709355Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowRightBold);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ArrowRightBold.836360bcc85c5fc7f281a1982487c81b.svg";